import client from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowRight } from "lucide-react";

export async function checkDuplicates(entity, fields) {
  try {
    const { data } = await client.post("/duplicate-check", { entity, fields });
    return data.matches || [];
  } catch {
    return [];
  }
}

export function DuplicateDialog({ open, matches = [], entityName = "entry", onContinue, onOpenExisting, onCancel }) {
  const n = matches.length;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-md" data-testid="duplicate-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-amber-700">
            <AlertTriangle className="h-5 w-5" /> Possible duplicate found
          </DialogTitle>
          <DialogDescription>
            {n === 1 ? `An existing ${entityName} looks very similar.` : `${n} existing ${entityName}s look very similar.`} Open the existing one, or add this as a new entry anyway.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-56 space-y-2 overflow-y-auto">
          {matches.map((m) => (
            <button
              key={m.id}
              onClick={() => onOpenExisting(m)}
              data-testid={`duplicate-match-${m.id}`}
              className="flex w-full items-center justify-between rounded-lg border border-slate-200 px-3 py-2 text-left transition-colors hover:border-sky-300 hover:bg-sky-50"
            >
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-slate-800">{m.label || "-"}</p>
                {m.sublabel ? <p className="truncate text-xs text-slate-500">{m.sublabel}</p> : null}
              </div>
              <ArrowRight className="h-4 w-4 shrink-0 text-slate-400" />
            </button>
          ))}
        </div>
        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-between">
          <Button variant="outline" onClick={onCancel} data-testid="duplicate-cancel">Cancel</Button>
          <Button className="bg-sky-600 hover:bg-sky-700" onClick={onContinue} data-testid="duplicate-continue">Add anyway</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
